import { useTranslate } from '@tolgee/react'
import { convertMinutesToHoursAndMinutes } from '../utils/date.utils'

export function useDateFormat() {
  const { t } = useTranslate()

  const formatMinutesToHoursAndMinutes = (minutes?: number | null) => {
    if (minutes == null || minutes === undefined) return null

    const { hours, minutes: mins } = convertMinutesToHoursAndMinutes(minutes)

    if (hours === undefined && mins === undefined) return null

    return hours && hours > 0
      ? t('hoursAndMinutes', '{hours} hrs {mins} mins', { hours, mins })
      : t('minutesOnly', '{mins} mins', { mins })
  }

  return { formatMinutesToHoursAndMinutes }
}
